import { createContext, useContext, useState } from 'react'

export interface WeatherData {
  temperatureC: number
  temperatureF: number
  unitC: string
  unitF: string
  description: string
  icon: string
  humidity: number
  windSpeed: number
  windUnit: string
  timezone: string
  lastUpdated: string
}

export interface LocationData {
  latitude: number
  longitude: number
  city?: string
  state?: string
  country?: string
  displayName?: string
}

interface WeatherContextValue {
  weather: WeatherData | null
  location: LocationData | null
  setWeather: (weather: WeatherData | null) => void
  setLocation: (location: LocationData | null) => void
}

const WeatherContext = createContext<WeatherContextValue | null>(null)

export function WeatherProvider({ children }: { children: React.ReactNode }) {
  const [weather, setWeather] = useState<WeatherData | null>(null)
  const [location, setLocation] = useState<LocationData | null>(null)

  return (
    <WeatherContext.Provider
      value={{ weather, location, setWeather, setLocation }}
    >
      {children}
    </WeatherContext.Provider>
  )
}

export function useWeather() {
  const context = useContext(WeatherContext)
  if (!context) {
    throw new Error('useWeather must be used within a WeatherProvider')
  }
  return context
}
